import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';
import logoWhite from '../assets/logo/fieldstech-logo-white.png';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById(sectionId);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-[#070D19]/95 backdrop-blur-md shadow-lg border-b border-white/10'
          : 'bg-[#070D19]/90 backdrop-blur-sm border-b border-white/[0.07]'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className={`flex items-center justify-between transition-all duration-300 ${
          scrolled ? 'h-20 sm:h-24' : 'h-24 sm:h-28'
        }`}>
          {/* Logo Oficial Fieldstech */}
          <div 
            onClick={() => navigate('/')} 
            className="flex items-center cursor-pointer group py-1"
          >
            <img
              src={logoWhite}
              alt="Fieldstech"
              className={`w-auto object-contain transition-all duration-300 group-hover:scale-105 drop-shadow-[0_0_16px_rgba(6,182,212,0.35)] ${
                scrolled ? 'h-12 sm:h-16' : 'h-14 sm:h-20 lg:h-24'
              }`}
            />
          </div>

          {/* Links de Navegación Centrados (como en el prototipo UX) */}
          <div className="hidden md:flex items-center gap-9">
            <button
              onClick={() => scrollToSection('servicios')}
              className="text-slate-300 hover:text-[#00C875] text-sm font-medium transition-colors duration-200"
            >
              Servicios
            </button>
            <button
              onClick={() => scrollToSection('por-que')}
              className="text-slate-300 hover:text-[#00C875] text-sm font-medium transition-colors duration-200"
            >
              ¿Por qué Fieldstech?
            </button>
            <button
              onClick={() => navigate('/contacto')}
              className="text-slate-300 hover:text-[#00C875] text-sm font-medium transition-colors duration-200"
            >
              Contacto
            </button>
          </div>

          {/* Botón de Acción Principal */}
          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              onClick={() => navigate('/contacto')}
              className="md:hidden text-slate-300 hover:text-white hover:bg-white/10 text-sm font-medium px-3 py-2"
            >
              Contacto
            </Button>
            <Button
              onClick={() => navigate('/diagnostico-gratuito')}
              className="bg-[#00C875] hover:bg-[#00E082] text-[#041E13] font-semibold px-5 sm:px-6 py-2.5 text-sm sm:text-base rounded-lg shadow-[0_0_24px_rgba(0,200,117,0.35)] hover:shadow-[0_0_30px_rgba(0,200,117,0.55)] hover:scale-[1.02] transition-all duration-300"
            >
              Diagnóstico gratuito
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
